export function NumbersBandSection() {
  return (
    <section className="py-16 md:py-20" data-testid="numbers-band">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6">
          {[
            { stat: "80%", label: "Reduction in client update calls" },
            { stat: "3+ hrs", label: "Saved per fee-earner per week" },
            { stat: "10 min", label: "From signup to first case live" },
            { stat: "100%", label: "England & Wales focus, statute-first" },
          ].map((n) => (
            <div key={n.label} className="text-center md:text-left">
              <p className="h-display text-4xl md:text-5xl" style={{ color: "#00D4AA" }}>{n.stat}</p>
              <p className="mt-2 text-sm text-slate-400 leading-snug max-w-[200px] mx-auto md:mx-0">{n.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
